import React from "react";
import { Flex, StepIndicator, Step } from "@jsq/ds/core";
import styles from "./styles";

type Props = {
  steps: Step[];
};

const StepNavigationIndicator: React.FunctionComponent<Props> = ({ steps }) => {
  return (
    <Flex flexDirection="row" css={styles.stepIndicator}>
      {steps.length > 1 && <StepIndicator steps={steps} disableStepLinks={true} />}
    </Flex>
  );
};

export default StepNavigationIndicator;
